var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"active-wrap",class:{'is-respone': _vm.respone}},[_c('div',{staticClass:"pic-wrap"},[_c('img',{staticClass:"m-img",attrs:{"src":_vm.img,"alt":""}})]),_c('div',{staticClass:"active-body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }